module.exports = __webpack_public_path__ + "img/Cover.342446f2.png";